import { connect, useDispatch } from "react-redux";
import Header from "../Header/Header";
import "./Register.scss";
import ProgressBar from "../DesignSystem/ProgressBar/ProgressBar";
import { useEffect, useState } from "react";
import { fetchPincodeDetails, registerUser, sendOTP, verifyOTP } from "../../store/thunks/register";
import fullLogo from "../../images/full_logo.svg";
import formImage from "../../images/image.png";
import AdditionalDetails from "./AdditionalDetails";
import PersonalDetails from "./PersonalDetails";
import registerSuccess from "../../images/svgs/register-success.svg";
import { useIntl } from "react-intl";
import { POPUPS, RESPONSE_STATUS_CODES, TOAST_STATE_DANGER } from "../../utils/constants";
import { showToast } from "../../store/thunks/toasts";
import { hidePopup, showPopup } from "../../store/thunks/popups";
import useCameraPermission from "../Shared/useCameraPermission";

export default connect((state) => ({ ...state.register }), {
	registerUser,
	sendOTP,
	verifyOTP,
	fetchPincodeDetails,
	showToast,
})(({ registerUserError }) => {
	const dispatch = useDispatch();
	const { formatMessage } = useIntl();

	const [progressLabels, setProgressLabels] = useState([
		{ id: 0, label: "personalDetails", isActive: true, isCompleted: false },
		{ id: 1, label: "additionalDetails", isActive: false, isCompleted: false },
	]);
	const [isActiveLabel, setIsActiveLabel] = useState(progressLabels[0].id);
	const [personalDetailsPayload, setPersonalDetailsPayload] = useState({});
	const [isRegistrationSuccessful, setIsRegistrationSuccessful] = useState(false);
	const [genericErrorMessage, setGenericErrorMessage] = useState("");
	const cameraPermission = useCameraPermission();

	const [registrationRules, setRegistrationRules] = useState([
		{
			id: 1,
			label: "public.registration.rule1",
			hasSubRules: false,
		},
		{
			id: 2,
			label: "public.registration.rule2",
			hasSubRules: false,
		},
		{
			id: 3,
			label: "public.registration.rule3",
			hasSubRules: false,
		},
		{
			id: 4,
			label: "public.registration.rule4",
			hasSubRules: false,
		},
		{
			id: 5,
			label: "public.registration.rule5",
			hasSubRules: false,
		},
		{
			id: 6,
			label: "public.registration.rule6",
			hasSubRules: false,
		},
		{
			id: 6,
			label: "public.registration.rule7",
			hasSubRules: true,
			subRules: [
				{
					label: "public.registration.rule7.rule1",
				},
				{
					label: "public.registration.rule7.rule2",
				},
				{
					label: "public.registration.rule7.rule3",
				},
			],
		},
	]);

	useEffect(() => {
		setTimeout(() => {
			(async () => {
				if (cameraPermission === "denied") {
					await dispatch(showPopup(POPUPS.PERMISSION_POPUP, { hideCloseButton: true }));
				} else {
					await dispatch(hidePopup(POPUPS.PERMISSION_POPUP));
				}
			})();
		}, 2000);
	}, [cameraPermission]);

	useEffect(() => {
		if (registerUserError && registerUserError.status_code) {
			if (registerUserError.status_code === RESPONSE_STATUS_CODES.USER_ALREADY_EXISTS) {
				dispatch(
					showToast({
						message: "public.register.userDuplicateError",
						type: TOAST_STATE_DANGER,
					})
				);
			}
		}
	}, [registerUserError]);

	const onNextButtonClick = (value) => {
		const updatedProgressLabels = progressLabels.map((label) => {
			if (label.id === isActiveLabel) {
				label.isCompleted = true;
			}

			if (label.label === "additionalDetails") {
				setIsActiveLabel(label.id);
				return { ...label, isActive: true };
			} else {
				return { ...label, isActive: false };
			}
		});

		setProgressLabels(updatedProgressLabels);
		setPersonalDetailsPayload(value);
	};

	const submitForm = async (additionalDetailsPayload) => {
		const payload = {
			...personalDetailsPayload,
			...additionalDetailsPayload,
		};

		const registerUserResponse = await dispatch(registerUser(payload));
		if (registerUserResponse) {
			setIsRegistrationSuccessful(true);
		} else {
			setIsRegistrationSuccessful(false);
			setGenericErrorMessage(formatMessage({ id: "public.register.failureMessage" }));
		}
	};

	return (
		<div>
			<Header />
			{!isRegistrationSuccessful ? (
				<>
					<img src={fullLogo} alt="full-logo" className="full-logo" />
					<div className="container-image">
						<img src={formImage} alt="form-image" />
					</div>
					<div className="register-form mt-32 flex direction-col align-items-start">
						<div className="text text-header--7 text-bold text-left mb-16">
							{formatMessage({ id: "public.title" })}
						</div>
						<div className="rules-section flex direction-col justify-content-start align-items-start mt-16 mb-16">
							<div className="text text-body--2 text-bold text-left text-primary">
								{formatMessage({ id: "public.rules" })}
							</div>
							<ul className="mt-16 text-left">
								{registrationRules.map((rule) => {
									return (
										<li>
											<div className="text text-body--4">{formatMessage({ id: rule.label })}</div>
											{rule.hasSubRules ? (
												<ul>
													{rule.subRules.map((subRule) => {
														return (
															<li>
																<div className="text text-body--4">
																	{formatMessage({ id: subRule.label })}
																</div>
															</li>
														);
													})}
												</ul>
											) : (
												<></>
											)}
										</li>
									);
								})}
							</ul>
							<div className="text text-body--4 text-left">
								{formatMessage({ id: "public.registration.rule.suggestion1" })}
							</div>
							<div className="text text-body--4 text-bold text-left mt-12 text-primary">
								{formatMessage({ id: "public.registration.rule.suggestion2" })}
							</div>
						</div>
						<ProgressBar labels={progressLabels} className="mt-16" />
						{isActiveLabel === 0 ? (
							<PersonalDetails
								onNextButtonClick={onNextButtonClick}
								sendOTP={sendOTP}
								verifyOTP={verifyOTP}
								genericErrorMessage={genericErrorMessage}
								setGenericErrorMessage={setGenericErrorMessage}
							/>
						) : (
							<></>
						)}
						{isActiveLabel === 1 ? (
							<AdditionalDetails
								fetchPincodeDetails={fetchPincodeDetails}
								onNextButtonClick={submitForm}
								genericErrorMessage={genericErrorMessage}
								setGenericErrorMessage={setGenericErrorMessage}
							/>
						) : (
							<></>
						)}
					</div>
				</>
			) : (
				<div className="flex direction-col align-items-center pa-16" style={{ marginTop: 120 }}>
					<img src={registerSuccess} alt="register-success" style={{ width: 200 }} />
					<div className="text text-header--6 mt-16">{formatMessage({ id: "public.register.success" })}</div>
					<div className="text text-body--3 mt-16">
						{formatMessage({ id: "public.register.successDescription" })}
					</div>
				</div>
			)}
		</div>
	);
});
